module.exports = __webpack_public_path__ + "static/img/cloner_chorus-1.ec234fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/cloner_chorus-1.png
// module id = QV3J
// module chunks = 12